export default function getResource(label, vars = []) {
    const resources = {
        linkedAccounts: 'Comptes liés',
        unlink: 'Dissocier',
        linkedOn: 'Lié à',
        unlinkAccount: 'Dissocier le compte',
        cancel: 'Annuler',
        areYouSure: `Êtes-vous sûr de vouloir dissocier votre compte Sephora de ${vars[0]}?`,
        unlinkSuccess: `Votre compte Sephora a été dissocié de ${vars[0]}.`,
        done: 'Terminé',
        faq: 'FAQ',
        unlinkError: `Nous sommes désolés. Une erreur s’est produite lors de la dissociation de votre compte. Veuillez réessayer ou communiquer avec Sephora par ${vars[0]} ou par téléphone au ${vars[1]}.`,
        editButton: 'Modifier',
        chat: 'Clavardage',
        unlinkConfirmation: `<h4>Are you sure you want to unlink your ${vars[0]} x ${vars[1]} account?</h4><ul><li>You won’t be receiving any benefits or promotion of lorem ipsum moving forward</li><li>Relinking in the future would mean you start fresh</li><li>You still won’t be able to redeem the special rewards if you already did this season lorem ipsum</li></ul><p>Find more <a href=\'#\'>${vars[0]} x ${vars[1]} FAQs</a></p><small>By tapping “Unlink Account” you have agreed to Sephora Terms and Privacy Policy and understood that all my stuff won’t be lorem ipsum, and this is the end of the road lorem ipsum.</small>`
    };

    return resources[label];
}
